import { Component, Input } from '@angular/core';
import { BillingTableRowType } from 'src/app/models/enums/billingTableRowType';
import { BillingTableResponse, BillingTableRow, RowTypeName } from './billing-table.interface';
import { DataService } from 'src/app/shared/services/data.service';
import { IconService } from 'src/app/shared/services/icon.service';

@Component({
  selector: 'app-billing-table',
  templateUrl: './billing-table.component.html',
  styleUrls: ['./billing-table.component.scss', './billing-table.component.en.scss']
})
export class BillingTableComponent {
  @Input() set data (value:BillingTableResponse){
    this.rowTypeNames = value.rowTypeNames;
    this.footnoteText = value.footnoteText;
    this.title = value.title;
    this.currencyName = value.currencyName;
    if(value.icon) {
      this.iconService.addIconToRegistry({
        key: value.icon,
        path: value.icon,
      });
      this.icon = value.icon;
    }
    
  }

  constructor(private dataService: DataService, private iconService: IconService) {}

  displayedColumns: string[] = ['name', 'balance', 'description', 'date'];
  dataSource: BillingTableRow[] = [];
  rowTypeNames: RowTypeName[] = [];
  footnoteText = '';
  title = '';
  icon = '';
  currencyName = '';
  BillingTableRowType = BillingTableRowType;
  loading: boolean = false;
  isServerError: boolean = false;

  ngOnInit() {
    this.loading = true;
    this.dataService.getBillingTableData().subscribe({
      next: (data) => {
        this.dataSource = data;
        this.loading = false;
      },
      error: (e) => {
        console.error(e);
        this.loading = false;
        this.isServerError = true;
      },
    });
  }

  getRowTypeName(type: BillingTableRowType): RowTypeName {
    const rowType = this.rowTypeNames.find(rowTypeName => rowTypeName.type === type);
    if(rowType === undefined) {
      return { type: type, description: "", title: "" };
    }
    return rowType;
  }

  convertBalanceValue(input: string): string {
    if (input.startsWith('-')) {
      return input.substring(1) + '-';
    }
    return input;
  }
}
